import groq from 'groq'
import mediaField from './media'
import galleryField from './gallery'
import formField from './form'

export default groq`{
  ...,
  media{
    ...${mediaField}
  },
  gallery[]{
    ...${galleryField}
  },
  testimonials[]->,
  ...${formField},
  link{
    url,
    external
  }
}`
